import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M9 5v14m0-14L6 8m3-3 3 3M15 19V5m0 14 3-3m-3 3-3-3" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5 12h13m-5-5 5 5-5 5" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_SharedCurrency = _resolveComponent("SharedCurrency")!
  const _component_SharedSelect = _resolveComponent("SharedSelect")!
  const _component_ApplicationFormScore = _resolveComponent("ApplicationFormScore")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('head'))
    }, [
      _createElementVNode("h2", {
        class: _normalizeClass(_ctx.b('head-title'))
      }, _toDisplayString(_ctx.$t("Параметры обмена")), 3),
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.b('live'))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.b('live-dot'))
        }, null, 2),
        _createTextVNode(" " + _toDisplayString(_ctx.$t("Курс live")), 1)
      ], 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('fields'))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('scores'))
      }, [
        _createVNode(_component_ApplicationFormScore, {
          class: _normalizeClass(_ctx.b('score', { from: true })),
          title: _ctx.$t('Со счета'),
          options: _ctx.displayedFromOptions,
          value: _ctx.displayedApplicationStoreRequest.currency_id_from,
          "onUpdate:value": _ctx.handleCurrencyIdFrom,
          onCreate: _ctx.handleCryptoCreate
        }, {
          "header-extra": _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('limits'))
            }, [
              (_ctx.pair)
                ? (_openBlock(), _createBlock(_component_UIButton, {
                    key: 0,
                    label: "МИН",
                    view: "max",
                    onClick: _ctx.handleMin
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_UIButton, {
                label: "МАКС",
                view: "max",
                onClick: _ctx.handleMax
              }, null, 8, ["onClick"])
            ], 2)
          ]),
          amount: _withCtx(() => [
            _createVNode(_component_SharedCurrency, {
              label: _ctx.displayedCurrencyName.toUpperCase(),
              value: 
                _ctx.currencyTypeAmountFormatter(
                  _ctx.displayedApplicationStoreRequest.currency_type_from,
                  _ctx.displayedApplicationStoreRequest.amount
                )
              ,
              "max-value": 
                _ctx.currencyTypeAmountFormatter(
                  _ctx.displayedApplicationStoreRequest.currency_type_from,
                  _ctx.displayedApplicationStoreRequest.max_amount
                )
              ,
              "is-number": true,
              "is-max-value": true,
              "is-error": _ctx.isErrorAmount,
              "onUpdate:value": _ctx.handleAmount
            }, null, 8, ["label", "value", "max-value", "is-error", "onUpdate:value"])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('available'))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t("Доступно")) + " ", 1),
              _createElementVNode("b", null, _toDisplayString(_ctx.currencyTypeAmountFormatter(
                    _ctx.displayedApplicationStoreRequest.currency_type_from,
                    _ctx.displayedApplicationStoreRequest.max_amount
                  )) + " " + _toDisplayString(_ctx.displayedCurrencyName.toUpperCase()), 1)
            ], 2),
            (_ctx.isRequisitesFromShow)
              ? (_openBlock(), _createBlock(_component_SharedSelect, {
                  key: 0,
                  class: _normalizeClass(_ctx.b('requisites')),
                  view: "light",
                  placeholder: _ctx.$t('Выберите реквизиты'),
                  options: _ctx.displayedRequisitesFromOptions,
                  value: 
                _ctx.displayedApplicationStoreRequest.user_requisite_id_from
              ,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((
                _ctx.displayedApplicationStoreRequest.user_requisite_id_from
              ) = $event))
                }, null, 8, ["class", "placeholder", "options", "value"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class", "title", "options", "value", "onUpdate:value", "onCreate"]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('divider'))
        }, [
          _hoisted_1,
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(_ctx.b('swap')),
            disabled: !_ctx.displayedApplicationStoreRequest.currency_id_to,
            "aria-label": "Поменять счета местами",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSwap && _ctx.handleSwap(...args)))
          }, [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass(_ctx.b('swap-icon', { rotating: _ctx.isSwapAnimating })),
              viewBox: "0 0 24 24",
              "aria-hidden": "true",
              onAnimationend: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSwapAnimationEnd && _ctx.handleSwapAnimationEnd(...args)))
            }, _hoisted_4, 34))
          ], 10, _hoisted_2),
          _hoisted_5
        ], 2),
        _createVNode(_component_ApplicationFormScore, {
          class: _normalizeClass(_ctx.b('score', { to: true })),
          title: _ctx.$t('На счет'),
          options: _ctx.displayedToOptions,
          value: _ctx.displayedApplicationStoreRequest.currency_id_to,
          "onUpdate:value": _ctx.handleCurrencyIdTo,
          onCreate: _ctx.handleCryptoCreate
        }, {
          amount: _withCtx(() => [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('receive-preview'))
            }, _toDisplayString(_ctx.isCommissionsShow ? _ctx.displayedAmount : "0,00"), 3)
          ]),
          footer: _withCtx(() => [
            (_ctx.isRequisitesToShow)
              ? (_openBlock(), _createBlock(_component_SharedSelect, {
                  key: 0,
                  class: _normalizeClass(_ctx.b('requisites')),
                  view: "light",
                  placeholder: _ctx.$t('Выберите реквизиты'),
                  options: _ctx.displayedRequisitesToOptions,
                  value: 
                _ctx.displayedApplicationStoreRequest.user_requisite_id_to
              ,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((
                _ctx.displayedApplicationStoreRequest.user_requisite_id_to
              ) = $event))
                }, null, 8, ["class", "placeholder", "options", "value"]))
              : _createCommentVNode("", true),
            (_ctx.pair)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(_ctx.b('pair-info'))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.pair.status), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("Мин:")) + " " + _toDisplayString(_ctx.pair.min) + " " + _toDisplayString(_ctx.pair.baseCoin), 1)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class", "title", "options", "value", "onUpdate:value", "onCreate"])
      ], 2),
      (
          _ctx.isRateLoading || _ctx.displayedApplicationStoreRequest.execution_price > 0
        )
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.b('rate'))
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('rate-title'))
            }, [
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("Текущий курс")), 1)
            ], 2),
            (_ctx.isRateLoading)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(_ctx.b('rate-skeleton')),
                  "aria-hidden": "true"
                }, _hoisted_9, 2))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(_ctx.b('rate-values'))
                }, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" 1 " + _toDisplayString(_ctx.displayedCurrencyName.toUpperCase()) + " = ", 1),
                    _createElementVNode("b", null, _toDisplayString(_ctx.displayedCourse), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayedCurrencyTo?.currency?.name.toUpperCase() ||
              _ctx.displayedCurrencyTo?.name.toUpperCase()), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _createTextVNode(" 1 " + _toDisplayString(_ctx.displayedCurrencyTo?.currency?.name.toUpperCase() ||
              _ctx.displayedCurrencyTo?.name.toUpperCase()) + " = ", 1),
                    _createElementVNode("b", null, _toDisplayString(_ctx.displayedCourseInverse), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayedCurrencyName.toUpperCase()), 1)
                  ])
                ], 2))
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('summary'))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('summary-label'))
        }, _toDisplayString(_ctx.$t("Вы получите")), 3),
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('summary-value'))
        }, [
          _createTextVNode(_toDisplayString(_ctx.isCommissionsShow ? _ctx.displayedAmount : "0,00") + " ", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.displayedCurrencyTo?.currency?.name.toUpperCase() ||
              _ctx.displayedCurrencyTo?.name.toUpperCase() ||
              ""), 1)
        ], 2),
        (_ctx.isCommissionsShow)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(_ctx.b('commission'))
            }, _toDisplayString(_ctx.$t("Комиссия")) + ": ~ " + _toDisplayString(_ctx.displayedCommission) + " " + _toDisplayString(_ctx.displayedCurrencyName.toUpperCase()), 3))
          : _createCommentVNode("", true)
      ], 2),
      (
          _ctx.displayedApplicationStoreRequest.currency_type_from === 'fiat' &&
          _ctx.displayedApplicationStoreRequest.currency_type_to === 'fiat' &&
          _ctx.displayedApplicationStoreRequest.amount >
            _ctx.displayedApplicationStoreRequest.max_amount
        )
        ? (_openBlock(), _createElementBlock("p", {
            key: 1,
            class: _normalizeClass(_ctx.b('message-error'))
          }, _toDisplayString(_ctx.$t("Не хватает средств")), 3))
        : _createCommentVNode("", true)
    ], 2),
    _withDirectives((_openBlock(), _createBlock(_component_UIButton, {
      view: "main",
      disabled: _ctx.isNextDisabled,
      onClick: _ctx.handleNext
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Далее")), 1),
        _hoisted_10
      ]),
      _: 1
    }, 8, ["disabled", "onClick"])), [
      [_directive_tooltip, 
        _ctx.notVerified
          ? _ctx.$t('Для получения доступа пройдите процедуру верификации')
          : null
      ]
    ])
  ], 2))
}